<template>
  <div>
    <div class="custom-table-list">
      <div class="custom-table-tr">
        <div class="custom-table-th">
          <span class="cell">报价信息</span>
        </div>
        <div class="custom-table-th">
          <span class="cell">订单总金额</span>
        </div>
        <div class="custom-table-th">
          <span class="cell">状态</span>
        </div>
        <div class="custom-table-th tc">
          <span class="cell">操作</span>
        </div>
      </div>
      <div v-loading="tableLoading" style="min-height: 200px">
        <div
          class="custom-table-item"
          v-for="(quoteItem, quoteIndex) in sourceData"
          :key="quoteIndex"
        >
          <div class="quote-table-item-desc">
            <div class="quote-table-item-desc-left">
              <span class="value"
                >报价编号：<span
                  class="mock-a"
                  @click="handleRouter(quoteItem)"
                  >{{ quoteItem.quoteId }}</span
                ></span
              >
              <span class="value"
                >询盘编号：<span
                  class="mock-a"
                  @click="handleGpRefDetail(quoteItem)"
                >
                  RFQ#{{ quoteItem.rfqId }}
                </span>
                <i
                  class="iconfont icon-file-copy ml5 cp"
                  style="color: #0863ff"
                  @click="copyToClipboard(quoteItem.rfqId)"
                ></i
              ></span>
              <span class="value" v-if="quoteItem.submitTime"
                >报价时间：{{
                  moment(quoteItem.submitTime).format('YYYY-MM-DD HH:mm')
                }}</span
              >
              <span class="value"
                >采购商：
                <span class="mock-a" @click="jump(quoteItem)">
                  {{ quoteItem.buyerCompanyName }}
                </span>
              </span>
            </div>
            <contractPopover
              :contractMap="contractMap"
              v-model="popoverVisible"
              v-if="showContractButton(quoteItem)"
            >
              <span
                class="value mock-button"
                slot="reference"
                @click="getContactInfo(quoteItem.rfqId,quoteItem)"
                >联系采购商</span
              >
            </contractPopover>
          </div>
          <div class="custom-table-item-tr">
            <!-- 报价信息 -->
            <div class="custom-table-td">
              <div class="quote-info-td">
                <div class="left">
                  <el-image
                    :src="`${partDrawingUrl}${quoteItem.partThumbnailsHashCode}`"
                    class="quote-image"
                    fit="contain"
                    :onerror="`this.src='${defaultRfqThn}'`"
                  />
                </div>
                <div class="right">
                  <el-tooltip effect="dark" placement="top">
                    <template slot="content">
                      <p style="max-width: 400px">
                        {{ quoteItem.rfqTitle || quoteItem.title }}
                      </p>
                    </template>
                    <span class="right-value">
                      {{ quoteItem.rfqTitle || quoteItem.title }}
                    </span>
                  </el-tooltip>
                  <span class="right-value">
                    {{ quoteItem.productNum }}款产品
                  </span>
                  <span class="right-value">
                    交货日期：{{
                      moment(quoteItem.deliveryDate[0]).format('YYYY-MM-DD')
                    }}
                    <span
                      v-if="
                        quoteItem.deliveryDate.length &&
                        quoteItem.deliveryDate.length > 1
                      "
                    >
                      ...多批次</span
                    >
                  </span>
                  <span class="right-value">
                    付款条款：{{ quoteItem.paymentTermsStr }}
                  </span>
                </div>
              </div>
            </div>
            <div class="custom-table-td">
              <span class="amount-text">{{ quoteItem.totalAmountStr }}</span>
            </div>
            <div class="custom-table-td">
              <span
                class="quote-status-item"
                :style="{
                  color: '#fff',
                  backgroundColor:
                    statusColorMap[quoteItem.quoteStatus] || '#B4BCC5',
                }"
                >{{ quoteItem.quoteStatusStr }}</span
              >
            </div>
            <!-- 操作 -->
            <div class="custom-table-td tc f-r-s-c">
              <p class="custom-search-button" @click="handleRouter(quoteItem)">
                查看报价详情
              </p>
            </div>
          </div>
        </div>
        <div v-if="!sourceData.length" class="empty-text">
          <p>暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contractPopover from './contract-popover.vue'
import moment from 'moment'
import { getContactInfoApi ,contactInfApi} from '@/utils/api/zhenyun.js'
import { onlineUrl, companyLogoUrl, partDrawingUrl } from '@/utils/config.js'
export default {
  name: 'quote-table',
  props: {
    sourceData: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    contractPopover,
  },
  data() {
    return {
      partDrawingUrl,
      companyLogoUrl: companyLogoUrl,
      tableLoading: false,
      contractMap: {
        name: '',
        positionStr: '',
        mobile: '',
        tel: '',
      },
      statusColorMap: {
        1: '#3062F8',
        2: '#3B9AFF',
        3: '#FF081F',
        4: '#B4BCC5',
        5: '#B4BCC5',
        6: '#05AEAE',
        7: '#FF7800',
        8: '#20B820',
      },
      loadingContactInfo: false,
      popoverVisible: false,
      defaultRfqThn:
        'https://res.haizol.com/base/images/default_rfq_thumb_56_56.png',
    }
  },
  methods: {
    moment,
    handleRouter(record) {
      this.$router.push({
        name: 'quote-detail',
        params: {
          id: record.quoteId,
        },
      })
    },
    showContractButton(item){
      if([7,8].includes(item.quoteStatus*1)){
        return true
      }
      if([30,50,70,90].includes(item.rfqSource) && [2,6,7,8].includes(item.quoteStatus*1)){
        return true
      }
      return false
    },
    jump(item) {
      window.open(
        `${onlineUrl}/comp/supplier/view-encrypt-buyer-profile/${item.buyerIdAes}`,
        '_blank'
      )
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('复制成功')
      } catch (err) {
        console.error('复制失败:', err)
      }
    },
    getContactInfo(id,item) {
      this.loadingContactInfo = true
      this.contractMap = {}
      let params = {}
      let apiType = undefined
      if([30,50,70,90].includes(item.rfqSource) && [2,6,7,8].includes(item.quoteStatus*1)){
        //这里是非甄云的获取联系人的接口
        apiType =  contactInfApi
        params ={
          relationId: id,
          compId: item.buyerCompany,
          source: 1,
          type: 4,
        }
      }else{
        apiType = getContactInfoApi
        params ={
          rfqId:id
        }
      }
      console.log(apiType,'apiType')
      apiType(params)
        .then((res) => {
          const { rspResult, data } = res
          if (rspResult.bizCode == 200) {
            this.contractMap = data || {}
            this.popoverVisible = true
          }
        })
        .finally(() => {
          this.loadingContactInfo = false
        })
    },
    handleGpRefDetail(item) {
      this.$router.push({
        name: 'order-radar-detail',
        params: {
          id: item.rfqId,
        },
        query:{
          quoteId:item.quoteId
        }
      })
    },
  },
  mounted() {
    //
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.custom-table-list {
  .custom-table-tr {
    display: grid;
    grid-template-columns: 2fr 1fr minmax(100px, 200px) minmax(100px, 150px);
    background: #f5f7fa;
    border-bottom: 1px solid #eee;
    .custom-table-th {
      padding: 12px 16px;
      overflow: hidden;
      color: #666666;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: SourceHanSansCN-Regular;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
  }
  .custom-table-item {
    border: 1px solid #e9edf1;
    margin-top: 8px;
    background: #fff;
    .quote-table-item-desc {
      display: flex;
      padding: 9px 16px;
      align-items: center;
      gap: 24px;
      background: #fbfbfb;
      .quote-table-item-desc-left {
        display: flex;
        align-items: center;
        gap: 56px;
      }
      .value {
        color: #666666;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
      }
    }
    .custom-table-item-tr {
      display: grid;
      grid-template-columns: 2fr 1fr minmax(100px, 200px) minmax(100px, 150px);
      .custom-table-td {
        padding: 12px 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .quote-info-td {
          display: flex;
          gap: 16px;
          .right {
            // margin: 10px 0;
            display: flex;
            flex-direction: column;
            gap: 4px;
            justify-content: center;
          }
          .quote-image {
            width: 120px;
            height: 120px;
            flex-shrink: 0;
            border-radius: 2px;
            border: 1px solid #cfd7de;
          }
          .right-value {
            display: block;
            color: #333333;
            font-family: SourceHanSansCN-Regular;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            -webkit-line-clamp: 2; /* 限制显示两行 */
            overflow: hidden; /* 隐藏超出范围的内容 */
            text-overflow: ellipsis; /* 使用省略号 */
          }
        }
        .amount-text {
          color: #333333;
          font-family: SourceHanSansCN-Medium;
          font-size: 14px;
          font-weight: 700;
          line-height: 22px;
        }
        .quote-status-item {
          color: #ffffff;
          font-family: SourceHanSansCN-Regular;
          font-size: 12px;
          font-weight: 400;
          padding: 3px 6px;
          background: #ff7800;
          width: fit-content;
          border-radius: 2px;
        }
      }
    }
  }
}
.tc {
  text-align: center;
}
.custom-search-button {
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background: #0863ff;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  flex-shrink: 0;
  cursor: pointer;
  width: fit-content;
}
.f-r-s-c {
  display: flex;
  align-items: center;
}
.mock-a {
  cursor: pointer;
}
.mock-a:hover {
  color: #0863ff;
}
.ml5 {
  margin-left: 5px;
}
.cp {
  cursor: pointer;
}
.mock-button {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  border: 1px solid #cfd7de;
  background: #fff;
  color: #0863ff !important;
  text-align: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}
.empty-text {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #666666;
  font-size: 14px;
}
</style>

